import React, { useState } from "react";
import * as Feather from "react-feather";
import { Link } from "react-router-dom";

const TopNavbarAdmin = ({ toggleSidebar, collapsed }) => {

  const [logged, setLogged] = useState(() => {
    return localStorage.getItem("isLoggedIn") === "true";
  });

  const handleLogout = () => {
    setLogged(false);
    localStorage.removeItem("isLoggedIn");
  };

  return (
    <nav
      className="top-navbar navbar navbar-expand navbar-light fixed-top"
      style={{
        left: collapsed ? "80px" : "250px",
        right: 0, 
        transition: "left 0.3s ease",
        backgroundColor: "#DFDCD7",
        zIndex: 1020,
      }}
    >
      <button
        className="btn"
        onClick={toggleSidebar}
        style={{
          background: "transparent",
          border: "none", marginRight: "10px"
        }}
      >
        <Feather.Menu size={24} color="black" />
      </button>

      <span
        style={{
          fontFamily: "Arial",
          fontWeight: "bold",
          fontSize: "20px",
          color: "black",
          marginLeft: "10px",
          textTransform: "capitalize",
        }}
      >
        {/* {authUser.username} */}
        Admin portal
      </span>

      <ul className="navbar-nav ml-auto ">
        <li className="nav-item">
          <Link to="/admin/login" className="nav-link" role="button">
            <button type="button" className="btn" onClick={handleLogout}>
              <Feather.LogOut />
            </button>
          </Link>
        </li>

      </ul>
    </nav>
  );
};

export default TopNavbarAdmin;
